import isNil from 'lodash/isNil';

export function updateList(list, resource, { idProp = 'id' } = {}) {
  if (isNil(list) || isNil(resource?.[idProp])) return;
  const item = list.find((entry) => entry[idProp] === resource[idProp]);
  if (item) Object.assign(item, resource);
}
